import { useEffect } from "react";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import {
  getPreProposalRouteWhenProductMissing,
  shouldRedirectToProductSelection
} from "../usePreProposal/navigation";
import { hasLayoutBandeirasProduct } from "@repo/core/utils/layoutBandeiras.utils";

export const useRequirePreProposalProduct = (strProduto?: string | null) => {
  const { replace } = useNavigation();
  const hasProduct = hasLayoutBandeirasProduct(strProduto);

  useEffect(() => {
    if (shouldRedirectToProductSelection(strProduto)) {
      replace(getPreProposalRouteWhenProductMissing());
    }
  }, [replace, strProduto]);

  return hasProduct;
};
